"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fns_1 = require("../helpers/fns");
class UsercomBrowserDriver {
    constructor() {
        this.name = 'UsercomBrowserDriver';
    }
    load() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                yield this.checkIfUsercomLoaded();
                return true;
            }
            catch (e) {
                return false;
            }
        });
    }
    supportsEvent(event) {
        return UsercomBrowserDriver.SUPPORTED_EVENTS.includes(event.name) || event.name.indexOf('custom.') >= 0;
    }
    track(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if ((0, fns_1.isCustomEvent)(event)) {
                return yield this.trackCustom(event);
            }
            const data = event.getData();
            switch (event.name) {
                case 'page_view':
                    return yield this.trackPageView(data);
                case 'add_payment_info':
                    return yield this.trackAddPaymentInfo(data);
                case 'add_to_cart':
                    return yield this.trackAddToCart(data);
                case 'purchase':
                    return yield this.trackPurchase(data);
                case 'view_item':
                    return yield this.trackViewItem(data);
                case 'user_data_update':
                    return yield this.updateUserData(data);
                case 'view_item_list':
                    return yield this.trackViewItemList(data);
                case 'login':
                    return yield this.trackLogin(data);
                case 'sign_up':
                    return yield this.trackSignUp(data);
                case 'subscribe':
                    return yield UsercomBrowserDriver.subscribe(data);
                case 'unsubscribe':
                    return yield UsercomBrowserDriver.unsubscribe(data);
                default:
                    throw new TypeError(`Event ${event.name} not supported!`);
            }
        });
    }
    trackPageView(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (window.UE) {
                window.UE.pageHit({
                    URL: data.pagePath
                });
            }
            this.push('event.page_view', {
                URL: data.pagePath
            });
        });
    }
    trackCustom(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = event.forDriver(this.name);
            if (data === null) {
                return;
            }
            if (typeof data.event_name !== 'string') {
                throw new TypeError(`Custom event ${event.name} has to provide event name for ${this.name} [forDriver.event_name]`);
            }
            if (data.event_payload && typeof data.event_payload !== 'object') {
                throw new TypeError(`Custom event ${event.name} has to provide event payload for ${this.name} [forDriver.event_payload]`);
            }
            return this.push(data.event_name, data.event_payload);
        });
    }
    push(eventName, payload) {
        if (window.userengage) {
            window.userengage(eventName, payload);
        }
    }
    checkIfUsercomLoaded(index = 0) {
        return new Promise((resolve, reject) => {
            if (index > UsercomBrowserDriver.LOAD_DRIVER_REPEATS) {
                reject();
            }
            if (window.userengage && window.UE) {
                resolve();
            }
            else {
                setTimeout(() => {
                    this.checkIfUsercomLoaded(index++)
                        .then(() => resolve())
                        .catch(() => reject());
                }, UsercomBrowserDriver.AVAILABILITY_CHECK_TIMEOUT);
            }
        });
    }
    monetaryValue(value) {
        return Math.round((value + Number.EPSILON) * 100) / 100;
    }
    trackLogin(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.push('event.sign_in', { method: data.method });
        });
    }
    trackSignUp(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.push('event.sign_in');
            this.push('client.update', {
                'First name': data.firstname,
                'Last name': data.lastname,
                email: data.email,
                shop_user_id: data.id,
                store_id: data.shop_id
            });
        });
    }
    updateUserData(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.push('client.update', {
                'First name': data.firstname,
                'Last name': data.lastname,
                email: data.email,
                shop_user_id: data.id,
                store_id: data.shop_id
            });
        });
    }
    trackAddPaymentInfo(data) {
        var _a, _b, _c, _d;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.push('event.checkout-data-step');
            this.push('client.update', {
                'First name': (_a = data.customer) === null || _a === void 0 ? void 0 : _a.firstname,
                'Last name': (_b = data.customer) === null || _b === void 0 ? void 0 : _b.lastname,
                email: (_c = data.customer) === null || _c === void 0 ? void 0 : _c.email,
                phone_number: (_d = data.customer) === null || _d === void 0 ? void 0 : _d.telephone
            });
        });
    }
    trackPurchase(data) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.push('event.purchase', {
                user_id: (_a = data.customer) === null || _a === void 0 ? void 0 : _a.id,
                order_id: data.transactionId,
                total: data.value ? this.monetaryValue(data.value) : undefined,
                value: data.value ? this.monetaryValue(data.value) : undefined,
                discount: data.discount ? this.monetaryValue(data.discount) : undefined,
                shipping: data.shipping ? this.monetaryValue(data.shipping) : undefined,
                tax: data.tax ? this.monetaryValue(data.tax) : undefined,
                coupon: data.coupon,
                currency: data.currency
            });
            data.items.forEach(item => {
                this.push('product_event', {
                    event_type: 'purchase',
                    list: item.listId,
                    product_id: item.sku,
                    name: item.name,
                    brand: item.brand,
                    sku: item.sku,
                    ean: item.ean,
                    category: [
                        item.category,
                        item.category2,
                        item.category3,
                        item.category4,
                        item.category5
                    ].filter(c => typeof c === 'string' && c.length).join(' > '),
                    variant: item.variant,
                    price: item.price ? this.monetaryValue(item.price) : undefined,
                    value: item.price ? this.monetaryValue(item.price) : undefined,
                    quantity: typeof item.qty !== 'undefined' ? item.qty : 1,
                    currency: item.currency,
                    position: item.index,
                    url: item.url,
                    image_url: item.image
                });
            });
        });
    }
    trackAddToCart(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            data.items.forEach(item => {
                this.push('product_event', {
                    event_type: 'add to cart',
                    list: item.listId,
                    product_id: item.sku,
                    name: item.name,
                    brand: item.brand,
                    sku: item.sku,
                    ean: item.ean,
                    category: [
                        item.category,
                        item.category2,
                        item.category3,
                        item.category4,
                        item.category5
                    ].filter(c => typeof c === 'string' && c.length).join(' > '),
                    variant: item.variant,
                    price: item.price ? this.monetaryValue(item.price) : undefined,
                    value: item.price ? this.monetaryValue(item.price) : undefined,
                    quantity: typeof item.qty !== 'undefined' ? item.qty : 1,
                    currency: item.currency,
                    position: item.index,
                    url: item.url,
                    image_url: item.image
                });
            });
        });
    }
    trackViewItem(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            data.items.forEach(item => {
                this.push('product_event', {
                    event_type: 'view',
                    list: item.listId,
                    product_id: item.sku,
                    name: item.name,
                    brand: item.brand,
                    sku: item.sku,
                    ean: item.ean,
                    category: [
                        item.category,
                        item.category2,
                        item.category3,
                        item.category4,
                        item.category5
                    ].filter(c => typeof c === 'string' && c.length).join(' > '),
                    variant: item.variant,
                    price: item.price ? this.monetaryValue(item.price) : undefined,
                    value: item.price ? this.monetaryValue(item.price) : undefined,
                    quantity: typeof item.qty !== 'undefined' ? item.qty : 1,
                    currency: item.currency,
                    position: item.index,
                    url: item.url,
                    image_url: item.image
                });
            });
        });
    }
    trackViewItemList(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            data.items.forEach(item => {
                this.push('product_event', {
                    event_type: 'view',
                    list: item.listId,
                    product_id: item.sku,
                    name: item.name,
                    brand: item.brand,
                    sku: item.sku,
                    ean: item.ean,
                    category: [
                        item.category,
                        item.category2,
                        item.category3,
                        item.category4,
                        item.category5
                    ].filter(c => typeof c === 'string' && c.length).join(' > '),
                    variant: item.variant,
                    price: item.price ? this.monetaryValue(item.price) : undefined,
                    value: item.price ? this.monetaryValue(item.price) : undefined,
                    quantity: typeof item.qty !== 'undefined' ? item.qty : 1,
                    currency: item.currency,
                    position: item.index,
                    url: item.url,
                    image_url: item.image
                });
            });
        });
    }
    static subscribe(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (window.UE) {
                window.UE.pageHit({
                    email: _data.email,
                    user_id: (new Date().getTime()).toString()
                });
            }
            if (window.userengage) {
                window.userengage('event.subscribe', {
                    email: _data.email,
                    list: _data.list,
                    newsletterAgreement: _data.allow_marketing,
                    allowPolicy: _data.allow_policy,
                    newsletterLanguage: _data.language,
                    storeCode: _data.storeCode
                });
            }
        });
    }
    static unsubscribe(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (window.userengage) {
                window.userengage('event.unsubscribe', {
                    email: _data.email
                });
            }
        });
    }
}
exports.default = UsercomBrowserDriver;
UsercomBrowserDriver.SUPPORTED_EVENTS = [
    'page_view',
    'add_payment_info',
    'add_to_cart',
    'purchase',
    'view_item',
    'view_item_list',
    'login',
    'subscribe',
    'unsubscribe'
];
UsercomBrowserDriver.AVAILABILITY_CHECK_TIMEOUT = 1500;
UsercomBrowserDriver.LOAD_DRIVER_REPEATS = 5;
//# sourceMappingURL=usercom.browser-driver.js.map